module.exports = __webpack_public_path__ + "static/img/server-name.4451f0c8.png";